import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActionPlanService } from 'src/app/core/services/action-plan.service';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { EnforcementService } from 'src/app/core/services/enforcement.service';


@Component({
  selector: 'app-enforcement',
  templateUrl: './enforcement.component.html',
  styleUrls: ['./enforcement.component.css']
})
export class EnforcementComponent implements OnInit {
  isArabic!: boolean;
  @Input() enforcementList: any;
  userData: any;
  enforcementCount: any;
  isHistorical?: boolean;

   constructor(private route: Router, private storageService: StorageService,
      private actionPlanService: ActionPlanService, private commonService: CommonService,private enforcementService: EnforcementService
    ) { }

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.userData = this.storageService.getSessionStorageData('userDetails');
    this.isHistorical = this.storageService.getSessionStorageData('isHistorical');
    if (this.enforcementList && this.enforcementList.length > 0) {
      const currentUrl = this.route.url; // full current URL

      this.enforcementList.forEach((item: { isActive: boolean; link: string; }) => {
        // mark active if current URL includes the item's link
        if(this.isHistorical && currentUrl.includes('enforcement/detail')){
          this.enforcementList[1].isActive = true;
        }else{
          item.isActive = currentUrl.includes(item.link);
        }
      });

      // Optional fallback: if no match, activate first item
      if (!this.enforcementList.some((item: { isActive: any; }) => item.isActive)) {
        this.enforcementList[0].isActive = true;
      }
      
    }
   
    this.enforcementService.enforcementCount$.subscribe(count => {
      if(count){
        this.enforcementCount = count;
      }else{
        this.enforcementCount = this.storageService.getSessionStorageData('enforcementCount');;
      }
    });
  }

    subscribeToEmitter(componentRef: any) {
      // if (!(componentRef instanceof  AssessmentSelectComponent)) {
      //   return;
      // }
      // const child: any = componentRef;
     
    
    }
 
   onListItemClick(selectedItemIdx: number) {
    this.enforcementList.forEach((v: any, i: any) => {
      if (i === selectedItemIdx) {
        v.isActive = true;
      } else {
        v.isActive = false;
      }
    });
     if (this.enforcementList[selectedItemIdx].link !== '') {
      let path = 'executor-dashboard/' + this.enforcementList[selectedItemIdx].link;
      this.route.navigate([path]);
    }
  }

}
